import React from 'react';
import {
  GDSStatus,
  ParagraphText,
  StatusBanner,
} from '@leagueplatform/genesis-core';

type StatusBannerData = {
  body?: string;
  heading?: string;
  status?: string;
};

export const GenericStatusBanner = ({
  heading,
  body,
  status,
}: StatusBannerData) => (
  <StatusBanner title={heading} status={status as GDSStatus}>
    <ParagraphText size="sm">{body}</ParagraphText>
  </StatusBanner>
);
